/** Mark installed PWA before game layout initializes (canvas resize). */
export function isPwaStandalone(): boolean {
  if (typeof window === "undefined") return false;
  const nav = window.navigator as Navigator & { standalone?: boolean };
  return (
    document.documentElement.classList.contains("pwa-installed") ||
    window.matchMedia("(display-mode: standalone)").matches ||
    window.matchMedia("(display-mode: fullscreen)").matches ||
    nav.standalone === true
  );
}

if (typeof window !== "undefined") {
  const nav = window.navigator as Navigator & { standalone?: boolean };
  const root = document.documentElement;
  const isIpadLike =
    /iPad/i.test(navigator.userAgent) ||
    navigator.platform === "iPad" ||
    (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
  if (
    window.matchMedia("(display-mode: standalone)").matches ||
    window.matchMedia("(display-mode: fullscreen)").matches ||
    nav.standalone === true
  ) {
    root.classList.add("pwa-installed");
  }
  if (isIpadLike) root.classList.add("touch-ipad");

  function measureSafeAreaTop(): number {
    const probe = document.createElement("div");
    probe.style.cssText =
      "position:fixed;top:0;left:0;height:0;padding-top:env(safe-area-inset-top);padding-top:constant(safe-area-inset-top);visibility:hidden;pointer-events:none";
    document.body.appendChild(probe);
    const inset = probe.getBoundingClientRect().height;
    probe.remove();
    return inset;
  }

  function syncTouchSafeTop(): void {
    if (!window.matchMedia("(pointer: coarse)").matches) return;
    const gap = 4;
    const measured = measureSafeAreaTop();
    let top = measured > 0 ? measured + gap : gap;
    if (measured <= 0) {
      const installed =
        root.classList.contains("pwa-installed") ||
        window.matchMedia("(display-mode: standalone)").matches ||
        nav.standalone === true;
      if (installed) top = (isIpadLike ? 24 : 20) + gap;
    }
    root.style.setProperty("--touch-safe-top", `${Math.ceil(top)}px`);
  }

  if (document.body) syncTouchSafeTop();
  else document.addEventListener("DOMContentLoaded", syncTouchSafeTop, { once: true });

  window.addEventListener("resize", syncTouchSafeTop);
  window.addEventListener("orientationchange", () => window.setTimeout(syncTouchSafeTop, 150));
  window.visualViewport?.addEventListener("resize", syncTouchSafeTop);
}
